import { render } from "./GameActivity.vue?vue&type=template&id=a740c252&scoped=true"
import script from "./GameActivity.vue?vue&type=script&lang=js"
export * from "./GameActivity.vue?vue&type=script&lang=js"

import "./GameActivity.vue?vue&type=style&index=0&id=a740c252&scoped=scoped&lang=less"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a740c252"]])

export default __exports__